import React, { useState, useEffect } from "react";
import ResidencySlider from "./ResidencySlider";
import { Link } from "react-router-dom";
// import { ChevronRight } from "lucide-react";
import { CheckCircle, ChevronRight, Building2, Calendar, Mail, Phone, Rocket, X, User } from "lucide-react";
import { fetchActivePrograms, saveStartupIdeaWithoutPayment } from "../../utils/api";
import toast from "react-hot-toast";
import { useQuery } from "@tanstack/react-query";
import ProgramTimer from "./ProgramTimer";
import ProgramTimerSkeleton from "./ProgramTimeSkeleton";

const ResidencyPage = () => {

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [formData, setFormData] = useState({

    founderName: "",
    founderEmail: "",
    founderPhone: "",
    cityOfResidence: "",
    startupName: "",
    cohortApplyingFor: "",


    startupPitch: "",
    problemDescription: "",
    targetUsers: "",
    solutionDescription: "",
    startupStage: "",
    hasMVP: "",
    mvpDescription: "",
    uniqueValueProposition: "",
    currentTraction: "",


    founderWhyFit: "",
    hasCoFounders: "",
    coreTeamDescription: "",


    hasRaisedFunding: "",
    fundingDetails: "",
    whyStrongCandidate: "",
    videoPitchFile: null,
    pitchDeckFile: null,
    founderLinkedIn: "",
    website: "",


    declarationAccepted: false,


    programType: "residency-program"
  })

  const [currentStep, setCurrentStep] = useState(1)

  const [isSubmitting, setIsSubmitting] = useState(false)

  const [processing, setProcessing] = useState(false);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  };


  const handleSubmit = async (e) => {
    setProcessing(true);

    try {
      // 1. Basic validation
      if (!formData.founderName || !formData.founderPhone || !formData.founderEmail) {
        toast.error("Please fill all required fields");
        setProcessing(false);
        return;
      }

      // 2. Clone form data
      let payload = { ...formData };

      // 3. Convert VIDEO file to base64 (if exists)
      if (formData.videoPitchFile) {
        const videoBase64 = await fileToBase64(formData.videoPitchFile);

        payload.videoPitchFile = videoBase64;
        payload.videoPitchFileName = formData.videoPitchFile.name;
        payload.videoPitchFileType = formData.videoPitchFile.type;
      }

      // 4. Convert PITCH DECK file to base64 (if exists)
      if (formData.pitchDeckFile) {
        const deckBase64 = await fileToBase64(formData.pitchDeckFile);

        payload.pitchDeckFile = deckBase64;
        payload.pitchDeckFileName = formData.pitchDeckFile.name;
        payload.pitchDeckFileType = formData.pitchDeckFile.type;
      }

      // 5. Send to backend
      const response = await saveStartupIdeaWithoutPayment(payload);

      toast.success(response.message);
      setIsModalOpen(false);
      setCurrentStep(1);

      // 6. Reset form
      setFormData({
        founderName: "",
        founderEmail: "",
        founderPhone: "",
        cityOfResidence: "",
        startupName: "",
        cohortApplyingFor: "",

        startupPitch: "",
        problemDescription: "",
        targetUsers: "",
        solutionDescription: "",
        startupStage: "",
        hasMVP: "",
        mvpDescription: "",
        uniqueValueProposition: "",
        currentTraction: "",

        founderWhyFit: "",
        hasCoFounders: "",
        coreTeamDescription: "",

        hasRaisedFunding: "",
        fundingDetails: "",
        whyStrongCandidate: "",
        videoPitchFile: null,
        pitchDeckFile: null,
        founderLinkedIn: "",
        website: "",

        declarationAccepted: false,
        programType: "residency-program"
      });

    } catch (error) {
      console.error("Something went wrong:", error);
      toast.error(error.message || "Something went wrong");
    } finally {
      setProcessing(false);
      setIsSubmitting(false);
    }
  };



  const { data, isLoading, refetch } = useQuery({
    queryKey: ["residency"],
    queryFn: () => fetchActivePrograms("residency")
  })

  useEffect(() => {
    console.log(data)
  }, [data])
  return (
    <>

      {isLoading ? <ProgramTimerSkeleton /> : data?.data?.length > 0 ? data?.data?.map((each) => (
        <ProgramTimer program={each} setIsModalOpen={setIsModalOpen}/>
      )) : ""}
      {/* -------------------------------------- */}
      {/* WHAT FOUNDERS EXPERIENCE INSIDE */}
      {/* -------------------------------------- */}

      <section className="py-10 px-6 md:px-20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          {/* LEFT CONTENT */}
          <div className="order-2 md:order-1">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-6">
              What is the TACTOS <br /><span className="text-[#fd3e3d]">Residency Program?</span>
            </h2>

            <p className="text-gray-700 text-lg max-w-xl leading-relaxed mb-10 text-justify">
              Startups spend 3 months living, working, building, and scaling
              within a high-performance environment. Each cohort is designed
              to produce startups with the TACTOS Seal of Investment
              Readiness.
            </p>
            {/* <div className="text-center">
              <button
                onClick={() => setIsModalOpen(true)}
                className="inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl transition w-full justify-center"
              >
                Apply Now
                <ChevronRight className="w-5 h-5" />
              </button>
            </div> */}


          </div>

          {/* RIGHT IMAGE */}
          <div className="order-1 md:order-2 flex justify-center md:justify-end">
            <img
              src="/residencypagenew.jpg"
              alt="Bootcamp"
              className="rounded-xl w-full max-w-md"
            />
          </div>

        </div>
      </section>
      <section className="py-10 px-6 md:px-20">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 tracking-wide">
          WHAT FOUNDERS <span className="text-[#fd3e3d]">EXPERIENCE INSIDE?</span>
        </h2>

        <div className="grid md:grid-cols-1 gap-10 items-start">

          {/* Left - Experience List */}
          <div className="space-y-6">
            {[
              "Daily execution and sprint-based productivity cycles",
              "Weekly performance reviews & KPI tracking",
              "Hands-on mentor sessions with CXOs, investors & domain leaders",
              "Continuous feedback on product, business model & strategy",
              "Pitch practice, storytelling & communication training",
              "Real customer validations and pilot testing",
              "Networking nights & founder circles",
            ].map((item, i) => (
              <div
                key={i}
                className="border rounded-2xl py-4 px-6 shadow-sm text-center text-lg font-medium bg-white"
              >
                {item}
              </div>
            ))}
          </div>

          {/* Right - Placeholder Image */}
       
        </div>
      </section>

      {/* -------------------------------------- */}
      {/* SELECTION PROCESS */}
      {/* -------------------------------------- */}
      <section className="py-10 px-6 md:px-20">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 tracking-wide">
          SELECTION  <span className="text-[#fd3e3d]">PROCESS</span>
        </h2>

        <div className="space-y-10">
          {/* Row 1 */}
          <div className="flex flex-col md:flex-row justify-center gap-6">
            {[
              [
                "Online application",
                "Apply online for the Residency Program before the deadline by submitting your startup details",
              ],
              [
                "Screening call",
                "Participate in focused screening calls where mentors evaluate your potential and readiness for the residency journey",
              ],
              [
                "Business model and Idea evaluation",
                "Your startup’s idea, scalability, and business model strength are analysed to ensure you meet the standards of the residency program",
              ],
            ].map(([title, desc], i) => (
              <div
                key={i}
                className="relative w-full md:w-[32%] border p-6 rounded-xl bg-white shadow-sm"
              >
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

                {/* Arrow Shape */}
                <div className="absolute right-[-25px] top-1/2 -translate-y-1/2 
                  w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
                  border-l-[#fd3e3d] drop-shadow-md hidden md:block"></div>
              </div>
            ))}
          </div>

          {/* Row 2 */}
          <div className="flex flex-col md:flex-row justify-center gap-6">
            {[
              [
                "Founder commitment assessment",
                "We assess your dedication, clarity, execution mindset to survive the residency program",
              ],
              [
                "Final selection of high-potential startups",
                "the most promising, committed, and scalable startups are invited to join the Residency Program",
              ],
            ].map(([title, desc], i, arr) => (
              <div
                key={i}
                className="relative w-full md:w-[34%] border p-6 rounded-xl bg-white shadow-sm"
              >
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

                {/* Arrow Shape */}
                {i !== arr.length - 1 && (
                  <div
                    className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
                  ></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <ResidencySlider />
      <section className="py-10 ">
        <div className="text-center max-w-3xl mx-auto">

          <h2 className="text-3xl font-bold mb-6 leading-tight">
            Apply For Summer <span className="text-[#fd3e3d]">2026 Program Now</span>
          </h2>

          <button
            // to="/instructions/investment"
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl transition-all"
          >
            Apply Now
            <ChevronRight className="w-5 h-5" />
          </button>

        </div>
      </section>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* BACKDROP */}
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setIsModalOpen(false)}
          />

          {/* MODAL */}
          <div className="relative w-full max-w-xl max-h-[98vh] rounded-2xl overflow-hidden shadow-2xl bg-white flex flex-col">

            {/* HEADER */}
            <div className="bg-black p-6 text-center relative shrink-0">
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute top-4 right-4 text-white/80 hover:text-white"
              >
                <X className="w-6 h-6" />
              </button>

              <div className="flex justify-center mb-3">
                <div className="bg-[#fd3e3d] p-3 rounded-full">
                  <Calendar className="w-8 h-8 text-white" />
                </div>
              </div>

              <h3 className="text-white text-2xl font-bold">
                Residency Program Application
              </h3>
            </div>

            {/* STEPPER */}
            <div className="px-6 py-6 shrink-0">
              <div className="flex items-center justify-between relative">
                <div className="absolute top-1/2 left-0 w-full h-[2px] bg-gray-300 -translate-y-1/2" />
                <div
                  className="absolute top-1/2 left-0 h-[2px] bg-[#fd3e3d] -translate-y-1/2 transition-all duration-500"
                  style={{ width: `${((currentStep - 1) / 4) * 100}%` }}
                />

                {[1, 2, 3, 4, 5].map(step => (
                  <div key={step} className="relative z-10">
                    <div
                      className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold
                    ${currentStep >= step
                          ? "bg-[#fd3e3d] text-white scale-110"
                          : "bg-gray-200 text-gray-500"}`}
                    >
                      {step}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* FORM (SCROLLABLE) */}
            <form className="flex-1 p-6 space-y-5 overflow-y-auto">

              {/* STEP 1 – FOUNDER INFORMATION */}
              {currentStep === 1 && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                  <div>
                    <label className="text-sm text-black/70">Founder Name</label>
                    <input
                      value={formData.founderName}
                      onChange={e => setFormData({ ...formData, founderName: e.target.value })}
                      placeholder="Founder Name"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">Email</label>
                    <input
                      value={formData.founderEmail}
                      onChange={e => setFormData({ ...formData, founderEmail: e.target.value })}
                      placeholder="Email"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">Phone Number</label>
                    <input
                      value={formData.founderPhone}
                      onChange={e => setFormData({ ...formData, founderPhone: e.target.value })}
                      placeholder="Phone Number"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">City of Residence</label>
                    <input
                      value={formData.cityOfResidence}
                      onChange={e => setFormData({ ...formData, cityOfResidence: e.target.value })}
                      placeholder="City of Residence"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">Startup Name</label>
                    <input
                      value={formData.startupName}
                      onChange={e => setFormData({ ...formData, startupName: e.target.value })}
                      placeholder="Startup Name"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">Cohort Applying For</label>
                    <input
                      value={formData.cohortApplyingFor}
                      onChange={e => setFormData({ ...formData, cohortApplyingFor: e.target.value })}
                      placeholder="Cohort Applying For"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                </div>
              )}


              {/* STEP 2 – STARTUP SNAPSHOT */}
              {currentStep === 2 && (
                <div className="grid grid-cols-1 gap-4">

                  <div>
                    <label className="text-sm text-black/70">
                      One line startup pitch (max 15 words)
                    </label>
                    <textarea
                      value={formData.startupPitch}
                      onChange={e => setFormData({ ...formData, startupPitch: e.target.value })}
                      placeholder="One line startup pitch (max 15 words)"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      Describe the problem you are solving
                    </label>
                    <textarea
                      value={formData.problemDescription}
                      onChange={e => setFormData({ ...formData, problemDescription: e.target.value })}
                      placeholder="Describe the problem you are solving"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      Who are your target users or customers
                    </label>
                    <textarea
                      value={formData.targetUsers}
                      onChange={e => setFormData({ ...formData, targetUsers: e.target.value })}
                      placeholder="Who are your target users or customers?"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      Describe your solution and core product
                    </label>
                    <textarea
                      value={formData.solutionDescription}
                      onChange={e => setFormData({ ...formData, solutionDescription: e.target.value })}
                      placeholder="Describe your solution and core product"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      Startup Stage (Idea / MVP / Early Revenue / Scaling)
                    </label>
                    <select
                      value={formData.startupStage}
                      onChange={e => setFormData({ ...formData, startupStage: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    >
                      <option value="">Startup Stage</option>
                      <option>Idea</option>
                      <option>MVP</option>
                      <option>Early Revenue</option>
                      <option>Scaling</option>
                    </select>
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      Do you currently have an MVP or working prototype?
                    </label>
                    <select
                      value={formData.hasMVP}
                      onChange={e => setFormData({ ...formData, hasMVP: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    >
                      <option value="">Yes / No</option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                  </div>

                  <div>
                    <label className="text-sm text-black/70">If yes, describe it</label>
                    <textarea
                      value={formData.mvpDescription}
                      onChange={e => setFormData({ ...formData, mvpDescription: e.target.value })}
                      placeholder="If yes, describe it"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      What is unique about your product or business model
                    </label>
                    <textarea
                      value={formData.uniqueValueProposition}
                      onChange={e => setFormData({ ...formData, uniqueValueProposition: e.target.value })}
                      placeholder="What is unique about your product or business model?"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      Current traction (users, pilots, revenue, partnerships, waitlist)
                    </label>
                    <textarea
                      value={formData.currentTraction}
                      onChange={e => setFormData({ ...formData, currentTraction: e.target.value })}
                      placeholder="Current traction (users, revenue, pilots, partnerships, waitlist)"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                </div>
              )}


              {/* STEP 3 – FOUNDER & TEAM */}
              {currentStep === 3 && (
                <div className="grid grid-cols-1 gap-4">

                  <div>
                    <label className="text-sm text-black/70">
                      Why are you the right founder(s) to solve this problem?
                    </label>
                    <textarea
                      value={formData.founderWhyFit}
                      onChange={e => setFormData({ ...formData, founderWhyFit: e.target.value })}
                      placeholder="Why are you the right founder(s) to solve this problem?"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">Do you have co-founders?</label>
                    <select
                      value={formData.hasCoFounders}
                      onChange={e => setFormData({ ...formData, hasCoFounders: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    >
                      <option value="">Yes / No</option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      If yes, describe the core team and roles
                    </label>
                    <textarea
                      value={formData.coreTeamDescription}
                      onChange={e => setFormData({ ...formData, coreTeamDescription: e.target.value })}
                      placeholder="If yes, describe the core team and roles"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                </div>
              )}


              {/* STEP 4 – FUNDRAISING & APPLICATION STRENGTH */}
              {currentStep === 4 && (
                <div className="grid grid-cols-1 gap-4">

                  <div>
                    <label className="text-sm text-black/70">
                      Have you raised funding before?
                    </label>
                    <select
                      value={formData.hasRaisedFunding}
                      onChange={e => setFormData({ ...formData, hasRaisedFunding: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    >
                      <option value="">Yes / No</option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                  </div>

                  <div>
                    <label className="text-sm text-black/70">If yes, provide details</label>
                    <textarea
                      value={formData.fundingDetails}
                      onChange={e => setFormData({ ...formData, fundingDetails: e.target.value })}
                      placeholder="If yes, provide details"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">
                      What makes your startup a strong candidate for TACTOS
                    </label>
                    <textarea
                      value={formData.whyStrongCandidate}
                      onChange={e => setFormData({ ...formData, whyStrongCandidate: e.target.value })}
                      placeholder="What makes your startup a strong candidate for TACTOS?"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">Video Upload</label>
                    <input
                      type="file"
                      onChange={e => setFormData({ ...formData, videoPitchFile: e.target.files[0] })}
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">Pitch Deck Upload</label>
                    <input
                      type="file"
                      onChange={e => setFormData({ ...formData, pitchDeckFile: e.target.files[0] })}
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">LinkedIn (Founder)</label>
                    <input
                      value={formData.founderLinkedIn}
                      onChange={e => setFormData({ ...formData, founderLinkedIn: e.target.value })}
                      placeholder="Founder LinkedIn"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-black/70">Website</label>
                    <input
                      value={formData.website}
                      onChange={e => setFormData({ ...formData, website: e.target.value })}
                      placeholder="Website"
                      className="w-full px-4 py-3 rounded-xl border border-black/20"
                    />
                  </div>

                </div>
              )}


              {/* STEP 5 – DECLARATION */}
              {currentStep === 5 && (
                <label className="flex items-start gap-3 text-sm text-black/60">
                  <input
                    type="checkbox"
                    checked={formData.declarationAccepted}
                    onChange={e =>
                      setFormData({ ...formData, declarationAccepted: e.target.checked })
                    }
                  />
                  I confirm that all information provided is accurate and I am applying
                  to TACTOS Residency Program with serious intent.
                </label>
              )}

              {/* NAVIGATION */}
              <div className="flex justify-between pt-4">
                {currentStep > 1 && (
                  <button
                    type="button"
                    onClick={() => setCurrentStep(s => s - 1)}
                    className="px-4 py-2 border rounded-lg"
                  >
                    Back
                  </button>
                )}

                <div className="ml-auto flex gap-3">
                  {currentStep < 5 && (
                    <button
                      type="button"
                      onClick={() => setCurrentStep(s => s + 1)}
                      className="px-6 py-2 bg-[#fd3e3d] text-white rounded-lg"
                    >
                      Next
                    </button>
                  )}

                  {currentStep === 5 && (
                    <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={processing}
                      className="px-6 py-2 bg-[#fd3e3d] text-white rounded-lg"
                    >
                      {processing ? "Loading" : "Submit"}
                    </button>
                  )}
                </div>
              </div>

            </form>
          </div>
        </div>
      )}

    </>
  );
};

export default ResidencyPage;
